import type { TQuoteMarkersPosition } from "./types";
import { quoteMarkersVariants } from "./variables";

export const QuoteMarkers = (position: TQuoteMarkersPosition) => {
  const QuoteMarkersElement = document.createElement("div");
  QuoteMarkersElement.className = `w-[.3125rem] h-[.3125rem] absolute top-0 bg-gray-200 -translate-y-1/2 ${quoteMarkersVariants[position]}`;

  return QuoteMarkersElement;
};
